import * as yup from 'yup';
import { treasurySetupFormFields } from '../../fields/formFields/treasurySetup';

export const treasurySetupSchema = yup.object({
  [treasurySetupFormFields.groupName]: yup
    .string()
    .max(150, 'Name must be at most 150 characters')
    .required('Group name is required')
    .trim(),
  [treasurySetupFormFields.externalPortfolioIds]: yup
    .array()
    .of(yup.number())
    .length(1, 'One product is required')
    .required('One product is required'),
  [treasurySetupFormFields.departmentName]: yup
    .string()
    .max(150, 'Name must be at most 150 characters')
    .required('Department name is required')
    .trim(),
  [treasurySetupFormFields.departmentDescription]: yup.string().trim(),
});
